import { useTranslation } from 'react-i18next';
import DataCollectionAdd from '../../shared/DataCollectionAdd.js';

const AddFinanceInstitutionForm = () => {
  const { t } = useTranslation();
  return (
    <>
      <input type="text" name="name" placeholder={t('institution')} required />
      <input type="text" name="matches" placeholder={t('aliases')} />
      <div>{t('aliases_hint')}</div>
    </>
  );
};

const getBodyFromForm = (formData) => {
  const name = formData.get('name');
  const extra = formData.get('matches') || '';
  const matches = extra ? `${name};${extra}` : name;
  return JSON.stringify({ name, matches });
};

export const AddFinanceInstitution = ({ onSuccess }) => (
  <DataCollectionAdd
    collection="finance.institutions"
    getBodyFromForm={getBodyFromForm}
    formElements={AddFinanceInstitutionForm}
    onSuccess={onSuccess}
  />
);

export default AddFinanceInstitution;
